import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryConfig } from "../baseQueryConfig ";

// authApi contains all the endpoints we want to use in the authentication
export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryConfig,
  tagTypes: ["AUTH"],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (loginRequest) => ({
        url: "auth/login",
        method: "POST",
        body: loginRequest,
      }),
    }),
    verifyCode: builder.mutation({
      query: (verifCodeRequest) => ({
        url: "auth/verifyCode",
        method: "POST",
        body: verifCodeRequest,
        credentials: "include",
      }),
      invalidatesTags: ["AUTH"],
    }),
    register: builder.mutation({
      query: (registerRequest) => ({
        url: "auth/register",
        method: "POST",
        body: registerRequest,
      }),
      invalidatesTags: ["AUTH"],
    }),
    logout: builder.mutation({
      query: () => ({
        url: "auth/logout",
        method: "POST",
        credentials: "include",
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ email, code, newPassword }) => ({
        url: "auth/reset-password",
        method: "POST",
        body: { email, code, newPassword },
        credentials: "include", // utile si tu utilises des cookies
      }),
    }),
    setPassword: builder.mutation({
      query: ({ email, password }) => ({
        url: "auth/set-password",
        method: "POST",
        body: { email, password },
        credentials: "include",
      }),
    }),
    checkAuth: builder.query({
      query: () => ({
        url: "auth/check-auth",
        method: "GET",
        credentials: "include", // Needed to send cookies
      }),
      providesTags: ["AUTH"],
    }),
    forgotPassword: builder.mutation({
      query: (body) => ({
        url: "/auth/forgot-passsword",
        method: "POST",
        body,
      }),
    }),
    resendVerificationCode: builder.mutation({
      query: (body) => ({
        url: "auth/resend-verification-code",
        method: "POST",
        body,
      }),
    }),
  }),
});

// Export hooks
export const {
  useLoginMutation,
  useRegisterMutation,
  useLogoutMutation,
  useVerifyCodeMutation,
  useResetPasswordMutation,
  useSetPasswordMutation,
  useForgotPasswordMutation,
  useCheckAuthQuery,
  useResendVerificationCodeMutation,
} = authApi;
export default authApi;
